import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=1afdcc5a&scoped=true&"
import script from "./fail.vue?vue&type=script&lang=ts&"
export * from "./fail.vue?vue&type=script&lang=ts&"
import style0 from "./fail.vue?vue&type=style&index=0&id=1afdcc5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdcc5a",
  null
  
)

export default component.exports